import type { BookingPacketDto } from '@lib/dto/sales-booking.dto'
import { dollarsFromCents } from '@lib/helpers/format'
import { quote } from '@lib/helpers/sales-money'
import { Card } from '@/components/ui/card'

/** Extras invoiced after signing (docs/sales.spec.md, "After signing"): what's on each and its total. Paid from the payments below. */
export function BookingInvoices({ invoices }: { invoices: readonly BookingPacketDto[] }) {
  if (invoices.length === 0) return null
  return (
    <section className="space-y-3 border-t border-line pt-6">
      <h2 className="m-0 text-lg font-semibold text-ink">Invoices</h2>
      <ul className="m-0 list-none space-y-3 p-0">
        {invoices.map((invoice) => {
          const total = quote(
            invoice.lines.map((l) => ({ ...l, key: l.id })),
            invoice.rates,
          )
          return (
            <Card asChild key={invoice.id} className="p-4">
              <li>
                <ul className="m-0 list-none space-y-1 p-0 text-sm">
                  {invoice.lines.map((l) => (
                    <li key={l.id} className="flex justify-between gap-3">
                      <span className="text-ink">
                        {l.name}
                        {l.quantity > 1 ? <span className="text-ink-muted"> × {l.quantity}</span> : null}
                      </span>
                      <span className="tabular-nums text-ink-muted">{dollarsFromCents(l.unitCents * l.quantity)}</span>
                    </li>
                  ))}
                </ul>
                <p className="m-0 mt-2 flex justify-between gap-3 border-t border-line pt-2 text-sm font-medium text-ink">
                  <span>Total, with tax and service charge</span>
                  <span className="tabular-nums">{dollarsFromCents(total.totalCents)}</span>
                </p>
              </li>
            </Card>
          )
        })}
      </ul>
    </section>
  )
}
